 import React, { useState, useEffect, useRef, useCallback } from "react";
import "./styles.css";
import NivoSwarmPlot from "../src/components/NivoSwarmPlot";
import _ from "lodash";
import { config_data } from "../src/config/config_stocks";
import SimpleLineNivo from "./Lines";
import * as d3 from "d3";
import ProminentAppBar from "../src/components/AppBar";
import { StickyContainer, Sticky } from "react-sticky";
import Box from "@material-ui/core/Box";

const xAxisVariable = "Ret5Days";
const sizeVariable = "MarketCap";
const colorVariable = "Ret5Days";
const outlierVariable = "MarketCap";
//PerFrom20DMA  Ret3Day PerFrom50DMA realtiveOptionVolume MarketCap
//Ret3Month Ret6Month Ret2Week iv30

//pass in data here

export default function Bubble({ in_data, sector, showAll, cumRetData }) {
  debugger;
  const [configData, setConfigData] = useState(config_data);
  const [clicked, setClicked] = useState("");
  const [currentIndex, setCurrentIndex] = useState(-1);
  const spreadsheetData = in_data;

  const spreadsheet_data = Array.from(spreadsheetData);
  // operator: Can change this  xmin and xMax based on need. Either by industry or by all data

  const sourced_data = _.map(spreadsheet_data, function (d) {
    return {
      Symbol: d["Symbol"],
      Name: d["Name"],
      Chg: +(+d["% Chg"] * 100).toFixed(2),
      MarketCap: +d["Market Cap"],
      PerFrom20DMA: +(+d["% From 20-Day MA"] * 100).toFixed(2),
      PerFrom50DMA: +(+d["% From 50-Day MA"] * 100).toFixed(2),
      PerFrom250DMA: +(+d["% From 250-Day MA"] * 100).toFixed(2),
      Ret2Week: +(+d["2-Week % Chg"] * 100).toFixed(2),
      Ret5Days: +(+d["5-Day % Chg"] * 100).toFixed(2),
      Ret3Month: +(+d["3-Month % Chg"] * 100).toFixed(2),
      Ret6Month: +(+d["6-Month % Chg"] * 100).toFixed(2),
      Ret1Year: +(+d["1-Yr % Chg"] * 100).toFixed(2),
      Ret3Day: +(+d["3-Day % Chg"] * 100).toFixed(2),
      group: d["Sector"],
      id: d["Symbol"],
      optionVolume: +d["Option Volume"],
      realtiveOptionVolume: +d["Relative Option Volume"],
      iv30: +d["IV30"]
    };
  });

  const min = d3.min(sourced_data, (d) => d[xAxisVariable]);
  const max = d3.max(sourced_data, (d) => d[xAxisVariable]);

  const outlierArray = _.map(sourced_data, (d) => d[outlierVariable]);
  const outlierArray_sorted = outlierArray.sort(d3.ascending);
  const q1 = d3.quantile(outlierArray_sorted, 0.25);
  const q2 = d3.quantile(outlierArray_sorted, 0.5);
  const q3 = d3.quantile(outlierArray_sorted, 0.75);
  const IQR = q3 - q1;
  const threshold = 1.5 * IQR;
  const isOutlier = (d) => d < q1 - threshold || d > q3 + threshold;

  const colors_returns = d3.scaleDiverging([min, 0, max], d3.interpolatePiYG);
  const sourced_data_with_colors = _.map(sourced_data, (obj) => {
    const fill_color = colors_returns(obj[colorVariable]);
    const stroke_color_check = isOutlier(obj[outlierVariable])
      ? "red"
      : "lightgray";
    const font_color = isOutlier(obj[xAxisVariable]) ? "black" : "black";

    return {
      ...obj,
      stroke_color: stroke_color_check,
      fill_color: fill_color,
      font_color: font_color
    };
  });

  const unique_industries = _.values([
    ...new Set(sourced_data_with_colors.map((item) => item.group))
  ]);
  // console.log(unique_industries)
  //OPERATOR
  const industry_to_filter_for = unique_industries[sector];

  const sourced_data_with_colors_filtered = _.filter(
    sourced_data_with_colors,
    (d) => d.group === industry_to_filter_for
  );

  function handleChildClick(node) {
    setClicked(node);
  }

  const data_to_show = showAll
    ? sourced_data_with_colors
    : sourced_data_with_colors_filtered;

  // TO FIX: Narrrow down options to chosen filter
  const options = _.map(data_to_show, (d) => {
    return {
      value: d.id,
      label: d.Name + " : " + d.id
    };
  });
  const options_sorted = _.sortBy(options, "value");

  function handleChangeSingle(d) {
    // const action = this.onChange.arguments[1].action
    // const last_element = _.last(d).value
    const last_element = d;
    // const options_array = this.options
    const selected_index = data_to_show
      .map(function (e) {
        return e.id;
      })
      .indexOf(last_element);
    setClicked(data_to_show[selected_index].id);
    setCurrentIndex(selected_index);
    const el = document.getElementById(last_element);

    if (el != null) {
      const top = el.getBoundingClientRect().y - window.innerHeight / 2;
      const left = el.getBoundingClientRect().x;
      window.scrollTo({
        top: top,
        left: left,
        behavior: "smooth"
      });
    }
  } // end handleChangeSingle
  return (
    <div className="App">
      <ProminentAppBar
        searchedFor={clicked}
        options_sorted={options_sorted}
        handleChange={handleChangeSingle}
        cumRetData={cumRetData}
      >
        <h1> X-Axis :{xAxisVariable} </h1>
      </ProminentAppBar>

      {sourced_data && !!sourced_data.length && (
        <NivoSwarmPlot
          data={data_to_show}
          xAxisVariable={xAxisVariable}
          sizeVariable={sizeVariable}
          groupVariable={"group"}
          onChildClick={handleChildClick}
          currentIndex={currentIndex}
          configData={configData}
          showAll={showAll}
          xAllMin={min}
          xAllMax={max}
        />
      )}
      <div
        draggable="true"
        style={{
          // position: "-webkit-stick",
          position: "fixed",
          top: "100px",
          zIndex: 10000,
          left: "50px",
          width: "100%"
        }}
      >
        <SimpleLineNivo in_data={cumRetData.filter((d) => d.id === clicked)} />
      </div>
    </div>
  );
}
